module.exports = __webpack_public_path__ + "static/media/step-1-filled.ab9d1f34.svg";